import * as loadjs from 'loadjs'
import Blocklist from '../blocklist/Blocklist'
import EventManager from '../eventManager/EventManager'
import Logger from '../helpers/Logger'
import WebModel from '../models/WebModel'
import { Recipe } from '../slots'
import { Slot } from '../slots/Slot'

export const CHICORY_SCRIPT_URL =
  '//www.chicoryapp.com/widget_v2/?location=below-ingredient&source=mediavine'
export const CHICORY_BUNDLE_NAME = 'chicory'

export default class Chicory {
  loaded = false

  constructor(model: WebModel, private blocklist: Blocklist) {
    if (!model.chicory) {
      return this
    }
    EventManager.on(EventManager.events.slotWrapperRenderEnded, (slot) =>
      this.load(slot)
    )
  }

  private load(slot: Slot): void {
    if (
      slot instanceof Recipe &&
      slot.target &&
      !slot.target.getAttribute('data-disable-chicory') &&
      !this.blocklist.contains(slot.adUnitId) &&
      !this.loaded
    ) {
      Logger.debug('Loading Chicory')
      this.loaded = true
      loadjs(CHICORY_SCRIPT_URL, CHICORY_BUNDLE_NAME)
    }
  }
}
